import Vue from "vue";
import Vuex from "vuex";

import users from "./users";
import lead from "./lead";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    lead,
  },
});
